import React from "react";
import { Link } from "react-router-dom";

import { IconButton } from "components";
import { Role } from "utils";

const EditUserButton = ({ user, tableType }) => {
  const canEdit = () => {
    if (Role.careHomeAccess()) {
    //   // TODO use userTableTypes from constants
      if (tableType === "users" && user.type === "thriver") return true;
      if (tableType === "users" && user.type === "caregiver") return true;
    //   if (tableType === "caregivers" && user.type === "caregiver") return true;
    }
    // if (Role.caregiverAccess()) {
    //   if (tableType === "users" && user.type === "thriver") return true;
    // }
    if (Role.adminAccess()) {
      // if (tableType === "carehomes") return true;
      if (tableType === "users" ) return true;
    }
    return false;
  };
  const isShowPermission = Role.careHomeAccess()  && tableType === "users" && user.type === "caregiver"
  const permissionVisibleToAdmin = Role.adminAccess()  && tableType === "users" && user.type === "caregiver"
  return canEdit() ? (
    <Link
      to={{
        pathname: `/user-profile`,
        state: { id: user.identifier , showPermissionBox : isShowPermission , permissionVisibleToAdmin : permissionVisibleToAdmin},
      }}
    >
      <IconButton
        name="Edit user"
        title={`Edit ${user.name}`}
        color="primary"
        icon="cil-pencil"
      />
    </Link>
  ) : null;
};

export default EditUserButton;
